import React from 'react';
import {Slider, SliderTrack, SliderFilledTrack, SliderThumb, SliderMark} from '@chakra-ui/react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

const labelStyles = {
  mt: '-2.5',
  width: '1',
  height: '5',
  backgroundColor: '#eef5f4',
  zIndex: '1',
};

const Questionnaire14Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_LIFESTYLE);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_LIFESTYLE]?.data,
  );
  const descIndex = questionnaire?.options?.findIndex(opt => opt?.value === currentAnswer?.selectedOption);
  const {inputs, setInputs} = useInput({
    selectedOption: descIndex === -1 || !descIndex ? 0 : descIndex,
  });
  const optionLength = questionnaire?.options?.length;
  const onClickSubmit = () => {
    const selectedOption = questionnaire?.options?.[inputs?.selectedOption];

    dispatch(
      setQuestionnaireAnswer({
        key: WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_LIFESTYLE,
        index: questionnaire?.index || '',
        data: {
          selectedOption: selectedOption?.value,
        },
      }),
    );
    dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.DESCRIBE_CURRENT_EATING_HABITS}));
  };

  const renderDesc = () => {
    const desc = questionnaire?.options?.[inputs?.selectedOption];
    return (
      <>
        <UiText fontWeight={700} fontSize={18} color="fadedJade" mb={4}>
          {desc?.label}
        </UiText>
        <UiText fontWeight={600} fontSize={14} color="fadedJade">
          {desc?.description}
        </UiText>
      </>
    );
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col className="slider-wrapper" alignItems="center" textAlign="center">
        <UiText my={10} variant="mdqTitle">
          {questionnaire?.questions?.default}
        </UiText>
        <Slider
          min={0}
          max={optionLength ? optionLength - 1 : 3}
          step={1}
          aria-label="slider-ex-1"
          defaultValue={inputs?.selectedOption}
          onChange={val => setInputs({selectedOption: val})}
          mb={10}
        >
          <SliderMark value={1} {...labelStyles}></SliderMark>
          <SliderMark value={2} {...labelStyles}></SliderMark>
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb style={{border: '2px solid #457672', width: '17px', height: '17px'}} />
        </Slider>
        {renderDesc()}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire14Screen;
